import { Helmet } from "react-helmet-async";

type Props = {
  title: string;
  description?: string;
  path?: string;
  keywords?: string[];
  image?: string;
  noindex?: boolean;
};

const SITE = "https://ozknews.com";

export default function Seo({
  title,
  description = "OZKNEWS — 호주 한인 뉴스·커뮤니티",
  path = "/",
  keywords = ["호주 뉴스", "한인 커뮤니티", "OZKNEWS"],
  image = `${SITE}/og-default.png`,
  noindex = false,
}: Props) {
  const url = `${SITE}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(", ")} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="OZKNEWS" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
